/**
 * Maps a workspace row from POST /v1/workspace/list to a UI-friendly shape.
 * Accepts camelCase (API) and snake_case fallbacks.
 *
 * @param {Record<string, unknown>} raw
 * @returns {{
 *   id: string,
 *   name: string,
 *   status: string,
 *   isActive: boolean,
 *   profilePhotoUrl: string,
 *   ownerName: string,
 *   membersCount: number,
 *   createdAt: string | null,
 *   updatedAt: string | null,
 * }}
 */
export const mapWorkspaceListItemToUi = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return {
      id: '',
      name: '',
      status: '',
      isActive: false,
      profilePhotoUrl: '',
      ownerName: '',
      membersCount: 0,
      createdAt: null,
      updatedAt: null,
    };
  }

  const id =
    (typeof raw.workspaceUuid === 'string' && raw.workspaceUuid) ||
    (typeof raw.workspace_uuid === 'string' && raw.workspace_uuid) ||
    (typeof raw.id === 'string' && raw.id) ||
    '';

  return {
    id,
    name: typeof raw.name === 'string' ? raw.name : '',
    status: typeof raw.status === 'string' ? raw.status : '',
    isActive: Boolean(raw.isActive ?? raw.is_active),
    profilePhotoUrl:
      (typeof raw.profilePhotoUrl === 'string' && raw.profilePhotoUrl) ||
      (typeof raw.profile_photo_url === 'string' && raw.profile_photo_url) ||
      '',
    ownerName:
      (typeof raw.ownerName === 'string' && raw.ownerName) ||
      (typeof raw.owner_name === 'string' && raw.owner_name) ||
      '',
    membersCount: Number(raw.userCount ?? raw.user_count ?? 0) || 0,
    createdAt:
      (typeof raw.createdAt === 'string' && raw.createdAt) ||
      (typeof raw.created_at === 'string' && raw.created_at) ||
      null,
    updatedAt:
      (typeof raw.updatedAt === 'string' && raw.updatedAt) ||
      (typeof raw.updated_at === 'string' && raw.updated_at) ||
      null,
  };
};
